export default {
    getFinanciadorId: (state) => state.financiadorId,
    getFinanciadorNom: (state) => state.financiadorNom,
    getFinanciadorUsaGecros: (state) => state.financiadorUsaGecros,
};
  